import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "./FirebaseConfig";
import Home from "./Home";
import Loader from "./components/Loader";
import Devo from "./Devo";

function RouterFile() {
  const [isLoading, setIsLoading] = useState(true);
  // const [isAuthenticated, setIsAuthenticated] = useState(false);

  // useEffect(() => {
  //     const unsubscribe = auth.onAuthStateChanged((user) => {
  //         setIsAuthenticated(!!user);
  //         setIsLoading(false);
  //     });

  //     return () => unsubscribe();
  // }, []);

  // if (isLoading) {
  //     return <Loader />;
  // }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/c/*" element={<Home />} />
        <Route path="/devo" element={<Devo />} />
        <Route path="/online" element={<Navigate to="/c/online" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RouterFile;
